// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"56728320","64":"4fbd53af","223":"5dd424a5","308":"c33be2b2","446":"11e9a1f9","536":"33359594"}[chunkId] + ".chunk.js";
};